module.exports = __webpack_public_path__ + "static/img/sec3-cont-img11@w.15d6ffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-history/sec3-cont-img11@w.jpg
// module id = yPDF
// module chunks = 0